import {
  GroupCodesController,
  TextFieldController,
} from '@/components/controls';
import { isOccurrenceNumber } from '@/utils';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from '@mui/material';
import { Fragment, useEffect } from 'react';
import { useForm } from 'react-hook-form';

export function UrgentActionEditorDialog({
  urgentAction,
  isOpen,
  onClose,
  onDelete,
  isDeleting,
}) {
  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: urgentAction,
  });

  useEffect(() => {
    reset(urgentAction);
  }, [reset, urgentAction, isOpen]);

  function handleClose() {
    onClose();
  }

  return (
    <form id="urgent-action-editor-form" onSubmit={handleSubmit(onClose)}>
      <Dialog open={isOpen && !!urgentAction} onClose={handleClose}>
        <DialogTitle>{`${
          urgentAction.code ? 'Edit' : 'Add'
        } Urgent Action`}</DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <DialogContentText gutterBottom>
              Please fill in the form below to add an urgent action. If groups
              are not specified then the action will be visible to all teams and
              all sectors.
            </DialogContentText>
            <GroupCodesController
              label="Groups"
              control={control}
              name="groupCodes"
              types={['SECTOR', 'TEAM']}
            />
            <TextFieldController
              name="occurrenceNumber"
              label="Occurrence Number"
              control={control}
              rules={{
                validate: async (value) =>
                  !value || (await isOccurrenceNumber(value)),
              }}
            />
            <TextFieldController
              name="description"
              label="Description"
              multiline
              minRows={8}
              control={control}
              rules={{ required: 'Required' }}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          {!!urgentAction.code && (
            <Fragment>
              <Button color="error" onClick={onDelete} disabled={isDeleting}>
                Sign Off
              </Button>
              <Box sx={{ flexGrow: 1 }} />
            </Fragment>
          )}
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            form="urgent-action-editor-form"
            type="submit"
            disabled={isSubmitting}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  );
}
